export default "__VITE_ASSET__Dj9ix1BT__"